import React from 'react';
import { classIf } from '../../utils/classIf';

function ScoreAndTime(props) {
    const [inProgress, showPartialScores, showTiming] = [props.state === 'in_progress', props.partialScores, props.timing != null];

    const show = inProgress || showPartialScores || showTiming;

    if (!show) {
        return null;
    }

    const scores = props.partialScores;
    const scoresCount = scores.length;

    return (
        <div className="d-flex align-items-center | mb_10_2_2">
            {inProgress && 
                <span className="live-badge | mb_10_2_2_1"></span>
            }
            {showPartialScores.length > 0 &&
                <>
                    <div className="d-flex align-items-flex-end | mb_10_2_2_2">
	                    <span className="text-small bold grey | mb_10_2_2_2_1">
		                    {props.partialScores.map((score, i) => {
		                    	let showableScore = score;
		                    	if (showableScore.indexOf('#') >= 0) {
                                    const parts = showableScore.split('#');
		                    		const [disc, effec] = [parts[0], parts[1]];
		                    		showableScore = `${disc}: ${effec}${i < scoresCount - 1 ? ' | ' : ''}`;
		                    	}
		                        return (
		                            <React.Fragment key={i}>
		                                <span className="score-container text-small bold grey | mb_10_2_2_2_1_1">{showableScore}</span>
		                            </React.Fragment>
		                        )
		                    })} 
	                    </span>
                    </div>
                    &nbsp;
                </>
            }
            {showTiming &&
                <>
                    <span className={"text-small grey | mb_10_2_2_2_3" + classIf(props.state === 'in_progress', 'lampeggia')}>{props.timing}</span>
                    &nbsp;
                </>
            }
        </div>
    );
}

export default ScoreAndTime;